// AUTO-GENERATED by scripts/generate-proof-answer.ts from the backend PKWiU ryczałt matrix
// and src/content/proof-answer/rulings.json — do not edit. Regenerate: bun run generate:proof-answer
import type { ProofAnswer } from './build-proof-answer';

export const PROOF_ANSWER: ProofAnswer = {
  pkd: '62.01.Z',
  taxYear: 2026,
  rows: [
    {
      pkwiu: '62.01.1',
      label: 'programming',
      rate: '12',
      statuteRef: 'Art. 12 ust. 1 pkt 2b lit. b uZPD',
    },
    {
      pkwiu: '62.01.2',
      label: 'softwareOriginals',
      rate: '12',
      statuteRef: 'Art. 12 ust. 1 pkt 2b lit. b uZPD',
    },
    {
      pkwiu: '62.02.20',
      label: 'softwareConsulting',
      rate: '12',
      statuteRef: 'Art. 12 ust. 1 pkt 2b lit. b uZPD',
    },
    {
      pkwiu: '62.02.30',
      label: 'itSupport',
      rate: '8.5',
      statuteRef: 'Art. 12 ust. 1 pkt 5 lit. a uZPD',
    },
    {
      pkwiu: '62.09',
      label: 'otherIt',
      rate: '8.5',
      statuteRef: 'Art. 12 ust. 1 pkt 5 lit. a uZPD',
    },
    {
      pkwiu: 'ex 62.09.20',
      label: 'softwareInstallation',
      rate: '12',
      statuteRef: 'Art. 12 ust. 1 pkt 2b lit. b uZPD',
    },
  ],
  rulings: [
    {
      signature: '0115-KDST2-2.4011.142.2025.3.KK',
      issuedOn: '2025-05-21',
      url: 'https://eureka.mf.gov.pl/informacje/podglad/640334',
      pkwiu: ['62.01.11', '74.10.19'],
      refusedRate: '8.5',
    },
    {
      signature: '0112-KDIL2-2.4011.1004.2022.4.IM',
      issuedOn: '2023-03-31',
      url: 'https://eureka.mf.gov.pl/informacje/podglad/538259',
      pkwiu: ['62.01.11'],
      refusedRate: '8.5',
    },
    {
      signature: '0115-KDIT1.4011.587.2022.1.MK',
      issuedOn: '2022-11-15',
      url: 'https://eureka.mf.gov.pl/informacje/podglad/517803',
      pkwiu: ['62.01.11', '62.01.12'],
      refusedRate: '8.5',
    },
  ],
};
